import { alpha, Box, Modal, Stack, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";
import { DefaultButton } from "..";
import { numberWithCommas } from "../../utils/stringFormat";


export default function PaymentPlansModal(props) {
    const { open, onClose, onFinish, currentPlan, plans } = props;

    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 480,
        maxWidth: 750,
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[currentMode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-payment-plans-title"
            aria-describedby="modal-payment-plans-description"
        >
            <Box sx={style}>
                <Typography
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.semiBold,
                        fontSize: Constants.Styles.fontSize.lg,
                        lineHeight: Constants.Styles.lineHeight.lg,
                    }}
                >
                    Plans
                </Typography>
                <Typography
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.medium,
                        fontSize: Constants.Styles.fontSize.sm,
                        lineHeight: Constants.Styles.lineHeight.sm,
                        mt: "1.5rem",
                        mb: "1.125rem",
                    }}
                >
                    Choose a plan that's right for you!
                </Typography>
                <Stack
                    direction={{
                        xs: "column",
                        sm: "row",
                    }}
                    spacing={"1rem"}
                >
                    {plans?.map((plan, index) => {
                        const selected = plan.plan === currentPlan;
                        return (
                            <Stack
                                key={index}
                                sx={{
                                    border: `1px solid ${Constants.Colors[currentMode].border}`,
                                    borderRadius: `calc(${Constants.Styles.radius.base} + 4px)`,
                                    color: Constants.Colors[currentMode].cardForeground,
                                    paddingBlock: `calc(${Constants.Styles.spacing} * 7)`,
                                    paddingInline: `calc(${Constants.Styles.spacing} * 3)`,
                                    backgroundColor: Constants.Colors[currentMode].card,
                                    boxShadow: selected ? `0px 1px 3px 0px ${Constants.Colors[currentMode].accent}` : "0px 1px 3px 0px #0000001a",
                                    borderColor: selected ? Constants.Colors[currentMode].accent : Constants.Colors[currentMode].border,
                                    borderWidth: selected ? 2 : 1,
                                }}
                                spacing={"1.25rem"}
                            >
                                <Stack
                                    direction={"row"}
                                    alignItems={"center"}
                                    justifyContent={"space-between"}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: Constants.Styles.fontWeight.semiBold,
                                            fontSize: Constants.Styles.fontSize.sm,
                                            lineHeight: Constants.Styles.lineHeight.base,
                                        }}
                                    >
                                        {plan.plan}
                                    </Typography>
                                    {selected && <Typography
                                        sx={{
                                            fontWeight: Constants.Styles.fontWeight.normal,
                                            fontSize: Constants.Styles.fontSize.xs,
                                            lineHeight: Constants.Styles.lineHeight.xs,
                                            color: Constants.Colors[currentMode].accent,
                                            backgroundColor: alpha(Constants.Colors[currentMode].accent, 0.1),
                                            paddingInline: `calc(${Constants.Styles.spacing} * 1)`,
                                            borderRadius: `calc(${Constants.Styles.radius.base} + 2px)`,
                                        }}
                                    >
                                        Current
                                    </Typography>}
                                </Stack>
                                <Stack
                                    direction={"row"}
                                    alignItems={"end"}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: Constants.Styles.fontWeight.normal,
                                            fontSize: Constants.Styles.fontSize["3xl"],
                                            lineHeight: Constants.Styles.lineHeight["3xl"],
                                            color: Constants.Colors[currentMode].ring,
                                        }}
                                    >
                                        ${plan.price}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: Constants.Styles.fontWeight.normal,
                                            fontSize: Constants.Styles.fontSize.sm,
                                            lineHeight: Constants.Styles.lineHeight.sm,
                                            color: Constants.Colors[currentMode].mutedForeground,
                                            pb: "0.25rem",
                                        }}
                                    >
                                        per month
                                    </Typography>
                                </Stack>
                                <Typography
                                    sx={{
                                        fontWeight: Constants.Styles.fontWeight.normal,
                                        fontSize: Constants.Styles.fontSize.sm,
                                        lineHeight: Constants.Styles.lineHeight.sm,
                                    }}
                                >
                                    {`up to ${numberWithCommas(plan.redirects)} redirects per month`}
                                </Typography>
                                <DefaultButton
                                    text={`Select`}
                                    onClick={() => onFinish(plan.plan)}
                                    size="small"
                                    disabled={selected}
                                />
                            </Stack>
                        );
                    })}

                </Stack>
            </Box>

        </Modal>
    );
}